module.exports = __webpack_public_path__ + "static/img_knock@2x-9adf9044afa993bdbd03463d6326d291.png";